import React from "react";

const MicroserviceItem = ({ 
  microservice, 
  onEdit, 
  onDelete, 
  onSelect, 
  isSelected = false, 
  isSelectable = false
}) => {
  const { id, title, description, price, category } = microservice;
  
  // Handlers for different actions
  const handleEdit = (e) => {
    e.stopPropagation();
    if (onEdit) onEdit(microservice);
  };
  
  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) onDelete(id);
  };
  
  const handleSelect = () => {
    if (isSelectable && onSelect) {
      onSelect(microservice);
    }
  };
  
  // Price formatting
  const formatPrice = (value) => {
    return value.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  if (isSelectable) {
    // Simplified view for selection in other components
    return (
      <div 
        className={`microservice-item ${isSelected ? 'selected' : ''}`}
        onClick={handleSelect}
      >
        <h4 className="microservice-title">{title}</h4>
        {description && (
          <div className="microservice-description">{description}</div>
        )}
        <div className="microservice-price">{formatPrice(price)}€</div>
        {category && (
          <div className="microservice-category">{category}</div>
        )}
        <button
          type="button"
          className="microservice-add-button"
          onClick={handleSelect}
          title={isSelected ? "Remove" : "Add"}
        >
          {isSelected ? "−" : "+"}
        </button>
      </div>
    );
  }
  
  // Normal view for the microservices list
  return (
    <div className="microservice-card">
      <div className="microservice-card__header">
        <h3 className="microservice-card__title">{title}</h3>
        {category && (
          <span className="microservice-card__category">{category}</span>
        )}
      </div>
      
      <div className="microservice-card__content">
        {description && (
          <div className="microservice-card__description">{description}</div>
        )}
        <div className="microservice-card__price">{formatPrice(price)}€</div>
      </div>
      
      <div className="microservice-card__footer">
        <button 
          className="microservice-card__edit-btn"
          onClick={handleEdit}
          title="Edit"
        >
          Edit
        </button>
        <button 
          className="microservice-card__delete-btn"
          onClick={handleDelete}
          title="Delete"
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default MicroserviceItem; 